/*
 *
 *  actions
 *
 */

import {
 
  LOAD_POST_DETAILS,
  LOAD_POST_DETAILS_SUCCESS,
  LOAD_POST_DETAILS_ERROR,


  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  LOAD_PRODUCT,
  LOAD_PRODUCT_SUCCESS,
  LOAD_PRODUCT_ERROR,

  ADD_TEAM_ASSIGN,
  ADD_TEAM_ASSIGN_SUCCESS,
  ADD_TEAM_ASSIGN_ERROR,

  

  ADD_MULTIPLE_TEAM_ASSIGN,
  ADD_MULTIPLE_TEAM_ASSIGN_SUCCESS,
  ADD_MULTIPLE_TEAM_ASSIGN_ERROR,

  
  UPDATE_PROCESS,
  UPDATE_PROCESS_SUCCESS,
  UPDATE_PROCESS_ERROR,

  LOAD_EVENT,
  LOAD_EVENT_SUCCESS,
  LOAD_EVENT_ERROR


 
} from "./constants"

export function loadRecordsCacheHit() {
  return {
   // type: LOAD_RECORDS_VALID_CACHE,
  }
}


export function loadPostDetails(searchFilter) {
  return {
    type: LOAD_POST_DETAILS,
    searchFilter,
  }
}


export function loadPostDetailsSuccess(post_details, success) {
  return {
    type: LOAD_POST_DETAILS_SUCCESS,
    post_details,
    success,
  }
}


export function loadPostDetailsError(error) {
  return {
    type: LOAD_POST_DETAILS_ERROR,
    error,
  }
}
export function loadProduct(productId) {
  return {
    type: LOAD_PRODUCT,
    productId,
  }
}


export function loadProductSuccess(product_details, success) {
  return {
    type: LOAD_PRODUCT_SUCCESS,
    product_details,
    success,
  }
}


export function loadProductError(error) {
  return {
    type: LOAD_PRODUCT_ERROR,
    error,
  }
}


export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}


export function addTeamAssign(team_details) {
  return {
    type: ADD_TEAM_ASSIGN,
    team_details,
  }
}

export function addTeamAssignSuccess(team_details) {
  return {
    type: ADD_TEAM_ASSIGN_SUCCESS,
    team_details
    
  }
}


export function addTeamAssignError(error) {
  return {
    type: ADD_TEAM_ASSIGN_ERROR,
    error,
  }
}

export function addMultipleTeamAssign(teamDetails) {
  return {
    type: ADD_MULTIPLE_TEAM_ASSIGN,
    teamDetails,
  }
}

export function  addMultipleTeamAssignSuccess() {
  return {
    type: ADD_MULTIPLE_TEAM_ASSIGN_SUCCESS,
    
    
  }
}

export function  addMultipleTeamAssignError(error) {
  return {
    type: ADD_MULTIPLE_TEAM_ASSIGN_ERROR,
    error,
  }
}


export function updateProcess(submitStatus) {
  return {
    type:UPDATE_PROCESS,
    submitStatus,
  }
}

export function updateProcessSuccess() {
  return {
    type: UPDATE_PROCESS_SUCCESS,
  }
}


export function updateProcessError(processError) {
  return {
    type: UPDATE_PROCESS_ERROR,
    processError,
  }
}

export function loadEvent(eventDetails) {
  return {
    type: LOAD_EVENT,
    eventDetails,
  }
}


export function loadEventSuccess(event_data, success) {
  return {
    type: LOAD_EVENT_SUCCESS,
    event_data,
    success,
  }
}


export function loadEventError(error) {
  return {
    type: LOAD_EVENT_ERROR,
    error,
  }
}
const actions = {
 loadPostDetails,
 loadPostDetailsSuccess,
 loadPostDetailsError,

  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  addTeamAssign,
  addTeamAssignSuccess,
  addTeamAssignError,

  addMultipleTeamAssign,
  addMultipleTeamAssignSuccess,
  addMultipleTeamAssignError,

  updateProcess,
  updateProcessSuccess,
  updateProcessError,

  loadEvent,
  loadEventSuccess,
  loadEventError,

  loadProduct,
  loadProductSuccess,
  loadProductError


}

export default actions
